import { useEffect, useRef } from "react";

import useAxiosPrivate from "@/api/hooks/useAxiosPrivate";
import useResponse from "@/shared/hooks/useResponse";
import { useDriversTableStore } from "@/stores/useTableStore";

import LayoutWrapper from "../../components/Layout/LayoutWrapper";
import DriversHeaderActions from "../../components/PageHeader/actions/pageHeaderActions/DriversHeaderActions/DriversHeaderActions";
import Table from "../../components/Table/Table";
import EditDriverDialog from "../../components/Table/actions/dialogs/Drivers/EditDriverDialog/EditDriverDialog";
import useDriversInlineActions from "../../components/Table/actions/inlineActions/hooks/useDriversInlineActions";
import useTableInlineActions from "../../components/Table/hooks/useTableInlineActions";
import { USER_PERMISSIONS } from "../../roles/types/enums";
import { ROUTES, TABLE_NAMES } from "../../shared";

const Drivers = () => {
  const { getData } = useAxiosPrivate();

  const { handleResponse } = useResponse();
  const { inlineActions, rowData, isOpen, closeDialog } =
    useDriversInlineActions();

  const { fetchData, resetInitialLoading, setIsCheckable, setInlineActions } =
    useDriversTableStore();

  const { tableInlineActions, allowedToManageData: allowedToManageDrivers } =
    useTableInlineActions(inlineActions, USER_PERMISSIONS.ManageDrivers);

  const hasFetched = useRef(false);

  useEffect(() => {
    if (!hasFetched.current) {
      resetInitialLoading();
      hasFetched.current = true;
      handlePageLoad();
    }
  }, []);

  useEffect(() => {
    updateDriversActions();
  }, [tableInlineActions]);

  const updateDriversActions = () => {
    setInlineActions(tableInlineActions);
    setIsCheckable(allowedToManageDrivers);
  };

  const handlePageLoad = async () => {
    await fetchData(getData, handleResponse);
    updateDriversActions();
  };

  return (
    <>
      <LayoutWrapper
        showDetailsSection
        tableName={TABLE_NAMES.Drivers}
        route={ROUTES.Drivers}
      >
        {allowedToManageDrivers ? <DriversHeaderActions /> : <></>}
      </LayoutWrapper>
      <Table hasDetails hasTableView route={ROUTES.Drivers} />

      {rowData && (
        <EditDriverDialog
          isOpen={isOpen}
          onClose={closeDialog}
          rowData={rowData}
        />
      )}
    </>
  );
};

export default Drivers;
